import React, { useMemo } from 'react';
import Title from '../../uiKit/typography/title';
import NewsCards from '../news/cards';
import { useTranslation } from 'react-i18next';
import { NavLink } from 'react-router-dom';
import { useGetMainNewsQuery, useGetNewsListQuery, useGetNewsTypesQuery } from '../../redux/api/common';

export default React.memo(function NewsBlock({ excludeId }) {
  const { t } = useTranslation('common');
  const { data = { news: [], pagesCount: 0 }, isFetching } = useGetNewsListQuery(1);
  const { data: mainNews, isFetching: isMainNewsFetching } = useGetMainNewsQuery();

  const filteredList = useMemo(() => {
    let res = [];
    if (mainNews) res.push(mainNews);
    res.push(...data.news);

    if (excludeId !== undefined) {
      res = res.filter(item => Number(item.id) !== Number(excludeId));
    }

    return res;
  }, [data.news, mainNews, excludeId]);

  const slicedList = useMemo(() => {
    return filteredList.slice(0, 3).map(item => ({
      imageSrc: item.icon,
      title: item.title,
      text: item.description,
      link: `/news/${item.urlName}`,
      newsType: item.newsType,
      id: item.id
    }));
  }, [filteredList]);

  return !isFetching && !isMainNewsFetching && !filteredList.length ? null : (
    <section className={'flex items-center flex-col w-full '}>
      <div className={'flex items-center justify-center w-full'}>
        <Title className={''}>
          {t('titles.whats_news')}
        </Title>

      </div>
      <div className={'w-full md:min-h-[434px] px-10'}>
        <NewsCards cardsData={slicedList} />
      </div>
      <div className={'flex flex-col md:flex-row w-full md:w-fit px-10 md:px-0 gap-4 mt-10 text-center'}>
        <NavLink to={'/news'}
                 className={({ isActive }) => `block w-full ${isActive ? '[&>span]:after:opacity-100' : '[&>span]:after:opacity-0'}`}>
            <span
              className={'block w-full py-[5px] px-[15px] font-medium text-[15px] leading-[2.07] rounded-lg bg-brandedColor text-white overflow-hidden '}>
              <span className={'relative'}>
                {t('buttons.read_news')}
              </span>
            </span>
        </NavLink>
      </div>
    </section>
);
})
